<script setup>
import { ConfigProvider } from 'ant-design-vue';
import adminLocale, { renderAntdEmpty } from '@/locale/antd';

const theme = {
    token: {
        colorPrimary: '#245a8c',
        colorInfo: '#245a8c',
        colorLink: '#245a8c',
        colorSuccess: '#2f6b4f',
        colorBgLayout: '#d8e0e8',
        colorTextBase: '#152536',
        borderRadius: 8,
        fontFamily:
            "'Noto Sans TC', 'PingFang TC', 'Microsoft JhengHei', system-ui, sans-serif"
    }
};
</script>

<template>
    <ConfigProvider
        :locale="adminLocale"
        :theme="theme"
        :render-empty="renderAntdEmpty"
    >
        <router-view />
    </ConfigProvider>
</template>

<style>
/* 全局樣式 */
html,
body {
    margin: 0;
    padding: 0;
    height: 100%;
    overflow: hidden;
}

#app {
    height: 100%;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: none; /* 防止橡皮筋效果 */
}
</style>
